module.exports = __webpack_public_path__ + "static/media/wave3.ba75e0c9.png";